import type { BaseRoute } from "@/routes/routes.mjs";
import lazyFn from "@/util/lazy-fn.mjs";

const fetchWikiData = lazyFn(
  () => import("@/game-minecraft/fetches/fetch-wiki-data.mjs"),
);

export const overlayRoutes: BaseRoute[] = [
  {
    path: "/minecraft/overlay/combined",
    component: "game-minecraft/CombinedOverlay.tsx",
    fetchData: () => fetchWikiData(),
  },
];
